import React, { useState, useEffect } from "react";
import {
  useNavigate,
  useLocation,
  Routes,
  Route,
  useParams,
} from "react-router-dom";
import {
  FiFileText,
  FiList,
  FiBarChart2,
  FiDatabase,
  FiMenu,
  FiEdit3,
  FiInfo,
  FiHome,
  FiPlusCircle,
  FiArrowLeft,
} from "react-icons/fi";
import { MdOutlineDesignServices } from "react-icons/md";
import { RiPencilFill } from "react-icons/ri";
import { FaPencilAlt } from "react-icons/fa";
import OHCAForm from "./forms/as7dk9f3n5v2x/forms/OHCAForm";
import SubjectList from "./forms/as7dk9f3n5v2x/dashboard/SubjectList";
import StatisticsPage from "./StatisticsPage";
import DQTPage from "./DQTPage";
import NewCase from "./newcase/NewCase";
import FormBuilder from "./formbuilder/FormBuilder";
import { useLanguage } from "../../contexts/LanguageContext";
import { getPageTitle } from "../../config/siteConfig";
import "./ECRFPage.css";

// VIP 프로젝트용 컴포넌트 임포트
import VIP10NewCase from "./newcase/vip/10/10NewCase";
import VIP10SubjectList from "./newcase/vip/10/10Subjectlist";
import VIP10Edit from "./newcase/vip/10/10Edit";
import VIP10DQT from "./newcase/vip/10/10DQT";
import VIP10Variable from "./newcase/vip/10/10Variable";
import VIP10Dashboard from "./newcase/vip/10/10Dashboard";
import VIP10ProjectInfo from "./newcase/vip/10/10ProjectInfo";
import VIP10Statistics from "./newcase/vip/10/10Statistics"; // 추가
import VIP10DBmanage from "./newcase/vip/10/10DBmanage"; // 추가
import { VscSymbolVariable } from "react-icons/vsc";
import { VscHome } from "react-icons/vsc"; // 홈 아이콘 추가

//VIP 11 : Neuro - ICU
import VIP11NewCase from "./newcase/vip/11/11NewCase";
import VIP11Variable from "./newcase/vip/11/11Variable";
import VIP11SubjectList from "./newcase/vip/11/11SubjectList";
import VIP11Edit from "./newcase/vip/11/11Edit";
import VIP11DBmanage from "./newcase/vip/11/11DBmanage";
import VIP11Statistics from "./newcase/vip/11/11Statistics";
import VIP11Read from "./newcase/vip/11/11Read";
import VIP11ReadOnly from "./newcase/vip/11/11ReadOnly";
import VIP11Datamanage from "./newcase/vip/11/11Datamanage";

// VIP 12 : REBOA RCT
import VIP12NewCase from "./newcase/vip/12/12NewCase";
import VIP12SubjectList from "./newcase/vip/12/12SubjectList";
import VIP12Statistics from "./newcase/vip/12/12Statistics";
import VIP12DBmanage from "./newcase/vip/12/12DBmanage";
import VIP12Variable from "./newcase/vip/12/12Variable";

// VIP 프로젝트 컴포넌트 매핑
const VIPComponents = {
  10: VIP10NewCase,
  11: VIP11NewCase,
  12: VIP12NewCase,
  // 추가 VIP 프로젝트 컴포넌트들
  // "15": VIP15NewCase,
  // "20": VIP20NewCase,
};

// VIP 프로젝트 SubjectList 컴포넌트 매핑
const VIPSubjectComponents = {
  10: VIP10SubjectList,
  11: VIP11SubjectList,
  12: VIP12SubjectList,
  // 추가 VIP 프로젝트 SubjectList 컴포넌트들
  // "15": VIP15SubjectList,
  // "20": VIP20SubjectList,
};

// VIP 프로젝트 Variable 컴포넌트 매핑
const VIPVariableComponents = {
  10: VIP10Variable,
  11: VIP11Variable,
  12: VIP12Variable,
};

// VIP 프로젝트 DQT 컴포넌트 매핑
const VIPDQTComponents = {
  10: VIP10DQT,
  // 향후 추가 VIP DQT 컴포넌트
};

// VIP 프로젝트 Dashboard 컴포넌트 매핑
const VIPDashboardComponents = {
  10: VIP10Dashboard,
};

// VIP 프로젝트 ProjectInfo 컴포넌트 매핑
const VIPProjectInfoComponents = {
  10: VIP10ProjectInfo,
};

// VIP 프로젝트 Edit 컴포넌트 매핑
const VIPEditComponents = {
  10: VIP10Edit,
  11: VIP11Edit,
  12: VIP12NewCase, // VIP12는 NewCase 컴포넌트에서 Edit 모드 처리
};

// VIP 프로젝트 DB 매니저 컴포넌트 매핑
const VIPDBmanageComponents = {
  10: VIP10DBmanage, // 추가
  11: VIP11DBmanage,
  12: VIP12DBmanage,
};

// VIP 프로젝트 통계 컴포넌트 매핑
const VIPStatisticsComponents = {
  10: VIP10Statistics,
  11: VIP11Statistics,
  12: VIP12Statistics,
  // 향후 다른 프로젝트의 통계 컴포넌트 추가 가능
};

// VIP 프로젝트 Read 컴포넌트 매핑
const VIPReadComponents = {
  11: VIP11Read,
};

// VIP 프로젝트 ReadOnly 컴포넌트 매핑
const VIPReadOnlyComponents = {
  11: VIP11ReadOnly,
};

// VIP 프로젝트의 Data Manager 컴포넌트 매핑
const VIPDatamanageComponents = {
  11: VIP11Datamanage,
};

// VIP 프로젝트별 기본 페이지 설정
const VIPDefaultPages = {
  10: "statistics", // VIP 10: 통계 페이지가 기본
  11: "statistics", // VIP 11: 통계 페이지가 기본
  12: "newcase", // VIP 12: REBOA RCT 신규 케이스가 기본
  // 추가 프로젝트별 기본 페이지 설정 가능
};

// 다국어 지원을 위한 번역 객체
const translations = {
  ko: {
    newCase: "신규 케이스",
    patientList: "환자 목록",
    dataQuality: "데이터 품질 관리",
    statistics: "통계",
    formBuilder: "폼 빌더",
    sketch: "스케치!",
    noDescription: "설명 없음",
    formBuilderTooltip: "폼 빌더로 이동",
    variableInfo: "변수 정보",
    projectInfo: "프로젝트 정보",
    dbManage: "DB 관리",
    read: "전체 보기", // 추가
  },
  en: {
    newCase: "New Case",
    patientList: "Patient List",
    dataQuality: "Data Quality Management",
    statistics: "Statistics",
    formBuilder: "Form Builder",
    sketch: "Sketch!",
    noDescription: "No description",
    formBuilderTooltip: "Go to Form Builder",
    variableInfo: "Variable Info",
    projectInfo: "Project Info",
    dbManage: "DB Management", // 추가
    read: "Read All", // 추가
  },
  ja: {
    newCase: "新規ケース",
    patientList: "患者リスト",
    dataQuality: "データ品質管理",
    statistics: "統計",
    formBuilder: "フォームビルダー",
    sketch: "スケッチ！",
    noDescription: "説明なし",
    formBuilderTooltip: "フォームビルダーへ移動",
    variableInfo: "変数情報",
    projectInfo: "プロジェクト情報",
    dbManage: "DB管理", // 추가
  },
  "zh-CN": {
    newCase: "新建案例",
    patientList: "患者列表",
    dataQuality: "数据质量管理",
    statistics: "统计",
    formBuilder: "表单构建器",
    sketch: "设计！",
    noDescription: "无描述",
    formBuilderTooltip: "前往表单构建器",
    variableInfo: "变量信息",
    projectInfo: "项目信息",
    dbManage: "数据库管理", // 추가
  },
  "zh-TW": {
    newCase: "新建案例",
    patientList: "患者列表",
    dataQuality: "數據質量管理",
    statistics: "統計",
    formBuilder: "表單構建器",
    sketch: "設計！",
    noDescription: "無描述",
    formBuilderTooltip: "前往表單構建器",
    variableInfo: "變數資訊",
    projectInfo: "專案資訊",
    dbManage: "資料庫管理", // 추가
  },
  fr: {
    newCase: "Nouveau Cas",
    patientList: "Liste des Patients",
    dataQuality: "Gestion de la Qualité des Données",
    statistics: "Statistiques",
    formBuilder: "Créateur de Formulaires",
    sketch: "Esquisse !",
    noDescription: "Pas de description",
    formBuilderTooltip: "Aller au Créateur de Formulaires",
    variableInfo: "Variables",
    projectInfo: "Informations Projet",
    dbManage: "Gestion DB", // 추가
  },
  de: {
    newCase: "Neuer Fall",
    patientList: "Patientenliste",
    dataQuality: "Datenqualitätsmanagement",
    statistics: "Statistik",
    formBuilder: "Formular-Generator",
    sketch: "Skizze!",
    noDescription: "Keine Beschreibung",
    formBuilderTooltip: "Zum Formular-Generator",
    variableInfo: "Variablen",
    projectInfo: "Projektinfo",
    dbManage: "DB-Verwaltung", // 추가
  },
  es: {
    newCase: "Nuevo Caso",
    patientList: "Lista de Pacientes",
    dataQuality: "Gestión de Calidad de Datos",
    statistics: "Estadísticas",
    formBuilder: "Constructor de Formularios",
    sketch: "¡Diseñar!",
    noDescription: "Sin descripción",
    formBuilderTooltip: "Ir al Constructor de Formularios",
    variableInfo: "Variables",
    projectInfo: "Información del Proyecto",
    dbManage: "Gestión de BD", // 추가
  },
};

const ECRFPage = () => {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { currentLanguage } = useLanguage();
  const [collapsed, setCollapsed] = useState(false);
  const [activeTab, setActiveTab] = useState("statistics");
  const [projectData, setProjectData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // 현재 언어에 따른 텍스트 가져오기
  const getText = (key) => {
    return translations[currentLanguage]?.[key] || translations["en"][key];
  };

  // VIP 프로젝트 여부 확인 함수
  const isVIPProject = () => {
    return projectData?.id && VIPComponents[projectData.id] !== undefined;
  };

  useEffect(() => {
    // 세션 스토리지에서 프로젝트 정보 가져오기
    const storedProject = sessionStorage.getItem("currentProject");
    if (storedProject) {
      try {
        const projectData = JSON.parse(storedProject);
        setProjectData(projectData);
        // 설정 파일을 사용한 동적 제목 설정
        document.title = getPageTitle("ecrf", {
          language: currentLanguage,
          projectName: projectData.name || "프로젝트",
        });
      } catch (error) {
        console.error("프로젝트 데이터 파싱 오류:", error);
      } finally {
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (isLoading) return;

    // 현재 경로에 따라 활성 탭 설정
    const path = location.pathname;
    if (path.includes("newcase")) {
      setActiveTab("newcase");
    } else if (path.includes("subjectlist")) {
      setActiveTab("subjectlist");
    } else if (path.includes("dqt")) {
      setActiveTab("dqt");
    } else if (path.includes("statistics")) {
      setActiveTab("statistics");
    } else if (path.includes("formbuilder")) {
      // VIP 프로젝트이고 formbuilder 경로인 경우 newcase로 리다이렉트
      if (isVIPProject()) {
        navigate("/ecrf");
        setActiveTab("newcase");
      } else {
        setActiveTab("formbuilder");
      }
    } else if (path.includes("variable")) {
      setActiveTab("variable");
    } else if (path.includes("projectinfo")) {
      setActiveTab("projectinfo");
    } else if (path.includes("dbmanage")) {
      setActiveTab("dbmanage");
    } else if (path.includes("read")) {
      setActiveTab("read");
    } else if (path === "/ecrf" || path === "/ecrf/") {
      // 정확히 /ecrf 경로인 경우 프로젝트별 기본 페이지로 설정
      const defaultPage = VIPDefaultPages[projectData?.id] || "statistics";
      setActiveTab(defaultPage);
    } else {
      // 알 수 없는 경로인 경우 프로젝트별 기본 페이지로 설정
      const defaultPage = VIPDefaultPages[projectData?.id] || "statistics";
      setActiveTab(defaultPage);

      // 기본 페이지로 네비게이션 (현재 경로가 기본 페이지와 다른 경우)
      if (!path.includes(defaultPage)) {
        navigate(`/ecrf/${defaultPage}`);
      }
    }

    // body에 ecrf-page 클래스 추가
    document.body.classList.add("ecrf-page");

    // 컴포넌트 언마운트 시 클래스 제거
    return () => {
      document.body.classList.remove("ecrf-page");
    };
  }, [location.pathname, navigate, isLoading, projectData]);

  const handleTabClick = (tab) => {
    // VIP 프로젝트이고 formbuilder 탭인 경우 이동을 막음
    if (tab === "formbuilder" && isVIPProject()) {
      return;
    }

    setActiveTab(tab);
    switch (tab) {
      case "newcase":
        try {
          // 새로운 케이스 생성을 위해 모든 관련 데이터 초기화
          sessionStorage.removeItem("currentCaseId");
          sessionStorage.removeItem("formData");
          sessionStorage.removeItem("editMode");
          sessionStorage.removeItem("editDataId");

          // 현재 페이지가 Edit 모드였다면 강제 새로고침으로 완전 초기화
          if (location.pathname.includes("/edit/")) {
            window.location.href = "/ecrf/newcase";
            return;
          }
        } catch (_) {}
        navigate("/ecrf/newcase");
        break;
      case "subjectlist":
        navigate("/ecrf/subjectlist");
        break;
      case "dqt":
        navigate("/ecrf/dqt");
        break;
      case "statistics":
        navigate("/ecrf/statistics");
        break;
      case "formbuilder":
        navigate("/ecrf/formbuilder");
        break;
      case "variable":
        navigate("/ecrf/variable");
        break;
      case "projectinfo":
        navigate("/ecrf/projectinfo");
        break;
      case "dbmanage":
        navigate("/ecrf/dbmanage");
        break;
      case "read":
        navigate("/ecrf/read");
        break;
      default:
        const defaultPage = VIPDefaultPages[projectData?.id] || "statistics";
        navigate(`/ecrf/${defaultPage}`);
    }
  };

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  const handleSketchClick = () => {
    // VIP 프로젝트인 경우 formbuilder로 이동하지 않음
    if (!isVIPProject()) {
      navigate("/ecrf/formbuilder");
    }
  };

  // 프로젝트에 따른 NewCase 컴포넌트 결정
  const getNewCaseComponent = () => {
    if (projectData?.id && VIPComponents[projectData.id]) {
      const VIPComponent = VIPComponents[projectData.id];
      return <VIPComponent projectId={projectData?.id} />;
    }
    return <NewCase projectId={projectData?.id} />;
  };

  // 프로젝트에 따른 SubjectList 컴포넌트 결정
  const getSubjectListComponent = () => {
    if (projectData?.id && VIPSubjectComponents[projectData.id]) {
      const VIPSubjectComponent = VIPSubjectComponents[projectData.id];
      return <VIPSubjectComponent projectId={projectData?.id} />;
    }
    return <SubjectList />;
  };

  // 프로젝트에 따른 DQT 컴포넌트 결정
  const getDQTComponent = () => {
    if (projectData?.id && VIPDQTComponents[projectData.id]) {
      const VIPDQT = VIPDQTComponents[projectData.id];
      return <VIPDQT projectId={projectData?.id} />;
    }
    return <DQTPage />;
  };

  // 프로젝트에 따른 Variable 컴포넌트 결정
  const getVariableComponent = () => {
    if (projectData?.id && VIPVariableComponents[projectData.id]) {
      const VarComp = VIPVariableComponents[projectData.id];
      return <VarComp projectId={projectData?.id} />;
    }
    return <div style={{ padding: "24px" }}>변수 정보가 없습니다.</div>;
  };

  // 프로젝트에 따른 ProjectInfo 컴포넌트 결정
  const getProjectInfoComponent = () => {
    if (projectData?.id && VIPProjectInfoComponents[projectData.id]) {
      const InfoComp = VIPProjectInfoComponents[projectData.id];
      return <InfoComp projectId={projectData?.id} />;
    }
    return <div style={{ padding: "24px" }}>프로젝트 정보가 없습니다.</div>;
  };

  // 프로젝트에 따른 DB 매니저 컴포넌트 결정
  const getDBmanageComponent = () => {
    if (projectData?.id && VIPDBmanageComponents[projectData.id]) {
      const DBmanageComp = VIPDBmanageComponents[projectData.id];
      return <DBmanageComp projectId={projectData?.id} />;
    }
    return <div style={{ padding: "24px" }}>DB 매니저가 없습니다.</div>;
  };

  // 프로젝트에 따른 Statistics/대시보드 컴포넌트 결정
  const getStatisticsComponent = () => {
    if (projectData?.id && VIPStatisticsComponents[projectData.id]) {
      const StatComp = VIPStatisticsComponents[projectData.id];
      return <StatComp projectId={projectData?.id} />;
    }
    return <StatisticsPage />;
  };

  // 프로젝트별 기본 컴포넌트 결정
  const getDefaultComponent = () => {
    const defaultPage = VIPDefaultPages[projectData?.id] || "statistics";

    switch (defaultPage) {
      case "newcase":
        return getNewCaseComponent();
      case "subjectlist":
        return getSubjectListComponent();
      case "dqt":
        return getDQTComponent();
      case "variable":
        return getVariableComponent();
      case "projectinfo":
        return getProjectInfoComponent();
      case "dbmanage":
        return getDBmanageComponent();
      case "read":
        return getReadComponent();
      case "statistics":
      default:
        return getStatisticsComponent();
    }
  };

  // getEditComponent 함수 수정
  const getEditComponent = () => {
    console.group("ECRFPage - getEditComponent");
    const { dataId } = useParams();
    const location = useLocation();

    console.log("Edit Component Params:", {
      dataId,
      locationState: location.state,
      projectId: location.state?.projectId,
      formData: location.state?.formData,
    });

    if (VIPEditComponents[location.state?.projectId]) {
      const EditComponent = VIPEditComponents[location.state?.projectId];
      console.log("Rendering VIP Edit Component:", {
        projectId: location.state?.projectId,
        formData: location.state?.formData,
      });
      console.groupEnd();
      return (
        <EditComponent
          projectId={location.state?.projectId}
          initialFormData={location.state?.formData} // formData 전달
        />
      );
    }

    console.log(
      "Edit component not found for project:",
      location.state?.projectId
    );
    console.groupEnd();
    return (
      <div>
        Edit component not found for project: {location.state?.projectId}
      </div>
    );
  };

  // 프로젝트에 따른 Read 컴포넌트 결정
  const getReadComponent = () => {
    if (projectData?.id && VIPReadComponents[projectData.id]) {
      const ReadComp = VIPReadComponents[projectData.id];
      return <ReadComp projectId={projectData?.id} />;
    }
    return <div style={{ padding: "24px" }}>읽기 전용 뷰가 없습니다.</div>;
  };

  // getReadOnlyComponent 함수 추가
  const getReadOnlyComponent = () => {
    console.group("ECRFPage - getReadOnlyComponent");
    const { dataId } = useParams();
    const location = useLocation();

    console.log("ReadOnly Component Params:", {
      dataId,
      locationState: location.state,
      projectId: location.state?.projectId,
      formData: location.state?.formData,
    });

    if (VIPReadOnlyComponents[location.state?.projectId]) {
      const ReadOnlyComponent =
        VIPReadOnlyComponents[location.state?.projectId];
      console.log("Rendering VIP ReadOnly Component:", {
        projectId: location.state?.projectId,
        formData: location.state?.formData,
      });
      console.groupEnd();
      return (
        <ReadOnlyComponent
          projectId={location.state?.projectId}
          initialFormData={location.state?.formData}
        />
      );
    }

    console.log(
      "ReadOnly component not found for project:",
      location.state?.projectId
    );
    console.groupEnd();
    return (
      <div>
        ReadOnly component not found for project: {location.state?.projectId}
      </div>
    );
  };

  // 세션 초기화 및 돌아가기 함수
  const handleReturn = () => {
    // 즉시 로딩 상태 제거
    setIsLoading(false);

    // 세션 스토리지 초기화
    sessionStorage.removeItem("selectedProject");
    sessionStorage.removeItem("projectId");
    sessionStorage.removeItem("projectData");
    sessionStorage.removeItem("formData");
    sessionStorage.removeItem("activeStep");
    sessionStorage.removeItem("currentCase");
    sessionStorage.removeItem("caseId");
    sessionStorage.removeItem("templateData"); // 템플릿 데이터도 제거

    // 로컬 상태 초기화
    setActiveTab("statistics");
    setProjectData(null);

    // 페이지 이동 전에 모든 상태 초기화를 보장
    setTimeout(() => {
      window.location.href = "/dashboard";
    }, 0);
  };

  if (isLoading) {
    return <div className="loading-container">로딩 중...</div>;
  }

  return (
    <div className="ecrf-layout">
      <div className={`ecrf-sidebar ${collapsed ? "collapsed" : ""}`}>
        <button className="toggle-sidebar" onClick={toggleSidebar}>
          {collapsed ? <FiMenu /> : <FiMenu />}
        </button>

        {projectData && !collapsed && (
          <div className="project-info">
            <h2>{projectData.name}</h2>
            <p>{projectData.description || getText("noDescription")}</p>
          </div>
        )}

        {/* 기존 사이드바 탭들 */}
        {isVIPProject() && (
          <>
            <div className="sidebar-tabs-container">
              <div
                className={`sidebar-tab ${
                  activeTab === "newcase" ? "active" : ""
                }`}
                onClick={() => handleTabClick("newcase")}
              >
                <FiFileText className="tab-icon" />
                {!collapsed && <span>{getText("newCase")}</span>}
              </div>

              <div
                className={`sidebar-tab ${
                  activeTab === "subjectlist" ? "active" : ""
                }`}
                onClick={() => handleTabClick("subjectlist")}
              >
                <FiList className="tab-icon" />
                {!collapsed && <span>{getText("patientList")}</span>}
              </div>

              {/* Read 탭 추가 */}
              {VIPReadComponents[projectData?.id] && (
                <div
                  className={`sidebar-tab ${
                    activeTab === "read" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("read")}
                >
                  <FiFileText className="tab-icon" />
                  {!collapsed && <span>{getText("read")}</span>}
                </div>
              )}

              {/* 데이터 품질, 통계 탭 - VIP 중 전용 DQT 컴포넌트가 있으면 표시 */}
              {(!isVIPProject() || VIPDQTComponents[projectData?.id]) && (
                <>
                  <div
                    className={`sidebar-tab ${
                      activeTab === "dqt" ? "active" : ""
                    }`}
                    onClick={() => handleTabClick("dqt")}
                  >
                    <FiDatabase className="tab-icon" />
                    {!collapsed && <span>{getText("dataQuality")}</span>}
                  </div>
                </>
              )}

              {/* 통계 탭 */}
              {isVIPProject() && (
                <div
                  className={`sidebar-tab ${
                    activeTab === "statistics" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("statistics")}
                >
                  <FiBarChart2 className="tab-icon" />
                  {!collapsed && <span>{getText("statistics")}</span>}
                </div>
              )}

              {/* Variable tab for VIP */}
              {isVIPProject() && (
                <>
                  <div
                    className={`sidebar-tab ${
                      activeTab === "variable" ? "active" : ""
                    }`}
                    onClick={() => handleTabClick("variable")}
                  >
                    <VscSymbolVariable className="tab-icon" />
                    {!collapsed && <span>{getText("variableInfo")}</span>}
                  </div>

                  {/* DB 관리 탭 */}
                  <div
                    className={`sidebar-tab ${
                      activeTab === "dbmanage" ? "active" : ""
                    }`}
                    onClick={() => handleTabClick("dbmanage")}
                  >
                    <FiDatabase className="tab-icon" />
                    {!collapsed && <span>{getText("dbManage")}</span>}
                  </div>

                  {/* ProjectInfo tab for VIP */}
                  {VIPProjectInfoComponents[projectData?.id] && (
                    <div
                      className={`sidebar-tab ${
                        activeTab === "projectinfo" ? "active" : ""
                      }`}
                      onClick={() => handleTabClick("projectinfo")}
                    >
                      <FiInfo className="tab-icon" />
                      {!collapsed && <span>{getText("projectInfo")}</span>}
                    </div>
                  )}
                </>
              )}
            </div>

            {/* 돌아가기 버튼 - 하단에 고정 */}
            <div className="sidebar-bottom-container">
              <div className="sidebar-tab return-button" onClick={handleReturn}>
                <FiArrowLeft className="tab-icon" />
                {!collapsed && <span>돌아가기</span>}
              </div>
            </div>
          </>
        )}
      </div>

      <div className={`ecrf-content ${collapsed ? "sidebar-collapsed" : ""}`}>
        <Routes>
          <Route exact path="/" element={getDefaultComponent()} />
          <Route path="/newcase" element={getNewCaseComponent()} />
          <Route path="/subjectlist" element={getSubjectListComponent()} />
          <Route
            path="/subjectlist/edit/:dataId"
            element={getEditComponent()}
          />
          <Route path="/dqt" element={getDQTComponent()} />
          <Route path="/statistics" element={getStatisticsComponent()} />
          {/* VIP 프로젝트가 아닌 경우에만 폼 빌더 라우트 활성화 */}
          {!isVIPProject() && (
            <Route path="/formbuilder" element={<FormBuilder />} />
          )}
          {isVIPProject() && (
            <Route path="/variable" element={getVariableComponent()} />
          )}
          {isVIPProject() && (
            <Route path="/projectinfo" element={getProjectInfoComponent()} />
          )}
          {isVIPProject() && (
            <Route path="/dbmanage" element={getDBmanageComponent()} />
          )}
          {isVIPProject() && (
            <Route path="/read" element={getReadComponent()} />
          )}
          {isVIPProject() && (
            <Route path="/read/view/:dataId" element={getReadOnlyComponent()} />
          )}
          {isVIPProject() && (
            <Route
              path="/subjectlist/edit/:dataId"
              element={getEditComponent()}
            />
          )}
        </Routes>
      </div>
    </div>
  );
};

export default ECRFPage;
